export default __webpack_public_path__ + "static/og-credit-score-72d4aa944c39aec6facd2183150375f0.jpg";